import { Skeleton } from '@/components/ui/skeleton'

const CompanyListingCardSkeleton = ({ count = 10 }: { count?: number }) => {
  return (
    <div className=" gap-2 flex flex-col w-full">
      {Array.from({ length: count }, (_, index) => (
        <div
          className=" flex flex-row bg-[#fdfdfd] rounded-[5px] border-[1px] border-solid border-[#ededed] p-5 min-w-[610px]"
          key={index}
        >
          <Skeleton className="h-[150px]  w-[20%] rounded-xl" />
          <div className=" flex flex-col  w-[70%] gap-4 ml-2">
            <Skeleton className="h-[15px]  w-[40%] rounded-xl" />
            <Skeleton className="h-[15px]  w-[40%] rounded-xl" />
            <Skeleton className="h-[15px]  w-[40%] rounded-xl" />
            <Skeleton className="h-[15px]  w-[40%] rounded-xl mt-4" />
            <Skeleton className="h-[15px]  w-[80%] rounded-xl" />
          </div>
        </div>
      ))}
    </div>
  )
}

export default CompanyListingCardSkeleton
